import { useNavigate, useLocation } from "react-router-dom";
import { useEffect, useState } from "react";
import apiClient from "../../../../shared/API/apiClient";
import { Gauge } from "lucide-react";

export default function NetFreshwaterDetails() {
  const navigate = useNavigate();
  const location = useLocation();

  // session fallback
  const saved = JSON.parse(sessionStorage.getItem("water_filters"));

  const reporting_year_id =
    location.state?.reporting_year_id || saved?.reporting_year_id;

  const legal_entity_id =
    location.state?.legal_entity_id || saved?.legal_entity_id;

  // state
  const [summary, setSummary] = useState({});
  const [sources, setSources] = useState([]);

  // API call
  useEffect(() => {
    if (!reporting_year_id || !legal_entity_id) return;

    const fetchData = async () => {
      try {
        const res = await apiClient.get(
          "/api/water-summary/freshwater-breakdown",
          {
            params: {
              reporting_year_id,
              legal_entity_id,
            },
          }
        );

        if (res.data.code === 200) {
          setSummary(res.data.summary || {});
          setSources(res.data.sources || []);
        }
      } catch (err) {
        console.error(err);
      }
    };

    fetchData();
  }, [reporting_year_id, legal_entity_id]);

  return (
    <div className="dash-page">
      {/* Header */}
      <div className="ws-title">Net Freshwater Use</div>
      <div className="ws-subtitle">
        Net freshwater drawn from the environment after offsetting recycled water
      </div>

      {/* Top Metric */}
      <div className="ws-top-metric">
        <Gauge size={22} />
        <span className="ws-top-value">
          {summary?.net_freshwater || 0}
        </span>
        <span className="ws-top-unit">m³ net freshwater</span>
      </div>

      {/* ================= CALCULATION CARD ================= */}
      <div className="ws-card">
        <div className="ws-card-title">Calculation</div>

        <div className="nf-calc-box">
          <div className="nf-row">
            <span>Gross Freshwater Intake</span>
            <span>{summary?.total_consumption || 0} m³</span>
          </div>

          <div className="nf-row">
            <span>Less: Recycled Water</span>
            <span>– {summary?.recycled || 0} m³</span>
          </div>

          <div className="nf-divider" />

          <div className="nf-row nf-total">
            <span>Net Freshwater Use</span>
            <span>{summary?.net_freshwater || 0} m³</span>
          </div>
        </div>
      </div>

      {/* ================= TABLE CARD ================= */}
      <div className="ws-card">
        <div className="ws-card-title">Freshwater Intake by Source</div>

        <table className="ws-table">
          <thead>
            <tr>
              <th>Source</th>
              <th style={{ textAlign: "right" }}>Quantity (m³)</th>
            </tr>
          </thead>

          <tbody>
            {sources.map((item, i) => (
              <tr key={i}>
                <td>{item.source}</td>
                <td style={{ textAlign: "right" }}>
                  {item.value}
                </td>
              </tr>
            ))}

            <tr className="ws-total-row">
              <td>Gross Freshwater Intake</td>
              <td style={{ textAlign: "right" }}>
                {summary?.total_consumption || 0}
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      {/* Back */}
      <div className="ws-back" onClick={() => navigate(-1)}>
        ← Back to Water Summary
      </div>
    </div>
  );
}